import localRobot from '@/common/localRobot.js';
import modelChoiceStore from '@/components/model-choice/store';
import global from '@/store/global';
import navbarStore from '@/store/navbar';
import { request } from '@src/common';
import { HelperCore } from '@src/common/helper';
import Other from "@/common/helper/other";
import Loader from '@src/common/helper/loader';
import { isEmpty } from "lodash-es";
import { makeAutoObservable, runInAction } from 'mobx';
import globalStore from '@/store/global';
import userStore from '@/store/user';
import slsLogger from '@public/log/sls';
import { Pingback } from '@shared/utils/pingback'

class Store {
  customAIbots = []; // 自定义模型
  officialAIbots = []; // 官方ai助手
  apiAIbots = []; // 三方API模型
  privateAIbots = []; // 私有API模型
  allInOneAIbots = []; // 一体机
  recommendAIbots = []; // 推荐ai助手
  bigModelAIbots = []; // 大模型
  curAIbotInfo = {};
  curSugInfo = {};
  total = 0;
  isModelListDirty = false;
  recoWord = '' // 从/hot/view/words接口返回数据随机选一个，用在标准搜索
  recoWordTimer = null // realshow 打点定时器
  showSearching = false; //发起AI搜索之后 在意图识别返回之前现在中转页面
  showCustomInputPage = false; // 是否展示自定义输入框页面
  currentAgentId = null; // 当前选中的智能体id
  currentAgentInfo = null; // ai搜索首页选中的智能体信息,用于智能体定制输入框页面.

  get tabList(){
     let list = global.cloudConfig.assistantAbilityTabMap?.category || '{}'
     try {
      list = JSON.parse(list)
      list = Object.keys(list).map(x=>{
        let item = list[x]
        item.category = x
        return item
      })
     } catch (error) {
      console.log(error);
      return []
     }
     return list
  }

  get sugList(){
    let list = global.cloudConfig.assistantAbilityTabList || []
    let obj = {}
    try {
     list.forEach(x=>{
      if(obj[x.category]) {
        obj[x.category].push(x)
      }else {
        obj[x.category] = [x]
        // obj[x.category] = this.tabList.filter(item => item.category == x.category)
      }
     })
    } catch (error) {
     console.log(error);
     return {}
    }
    return obj
 }

  constructor() {
    makeAutoObservable(this);

    if (!HelperCore.IS_ONLINE) {
      window._homeStore = this;
    }
    this.getHotwords()
  }

  setData (key, value) {
    this[key] = value;
  }

  setDirty(bool = true) {
    this.isModelListDirty = bool;
    this.isModelListDirty = bool;
  }

  updateModelList = (shouldCheckDirty) => {

    if (shouldCheckDirty && !this.isModelListDirty) {
      return
    }

    this.isModelListDirty = false
    return this.getOfficialAIbot()
  }

  /** 定制智能体输入框页面显示 */
  setShowCustomInputPage = (bool) => {
    this.showCustomInputPage = bool;
  }

  /** 设置当前选中的智能体id 用于智能体定制输入框页面*/
  setCurrentAgentId = (id) => {
    this.currentAgentId = id;
  }

  /** 设置当前选中的智能体信息 用于智能体定制输入框页面*/
  setCurrentAgentInfo = (info) => {
    this.currentAgentInfo = info;
  }

  closeCustomInputPage = () => {
    this.showCustomInputPage = false;
    this.currentAgentInfo = null;
    this.currentAgentId = null;
  }

  improveDSPriority = (list) => {
    return list
  }
  /**
   * 首页模型列表
   * @param {(10 | 100)} modelType 10 - 广场模型列表， 100 - 自定义模型列表
   */
  getOfficialAIbot = () => {
    const { pushFrontId, switchCurId, curId } = modelChoiceStore;

    return request
      .get('/robot/platform', {
        params: {chat_type: 10, ai_agent: 1} // ai_agent设置为1时，返回AI智能体
      })
      .then(res => {
        const list = (res.data?.list || []).concat(localRobot.localModels);
        navbarStore.setChatModels(list);
        this.total = res.data?.total || res.data?.list.length || 0;
        runInAction(() => {
          this.customAIbots = list.filter(item => item.chat_type === 100);
          // this.officialAIbots = list.filter(item => item.chat_type === 10 || item.state === 1);
          this.officialAIbots = list.filter(item => item.model_type === 0);
          this.apiAIbots = list.filter(item => item.model_type === 2 && item.model_tab === '2');
          this.privateAIbots = list.filter(item => item.model_type === 3);
          this.allInOneAIbots = list.filter(item => item.model_type === 4);
          this.bigModelAIbots = list.filter(item => item.model_type === 2 && item.model_tab === '1');

          if (!list.find(model => model.id === curId)) {
            // 如果旧的不在了 则切换到第一个
            const index = this.officialAIbots.findIndex((item) => item.title && /deepseek.*满血/i.test(item.title));
            if (index !== -1) {
              pushFrontId(this.officialAIbots[index].id)
              switchCurId(this.officialAIbots[index].id);
            } else {
              pushFrontId(this.officialAIbots[0].id)
              switchCurId(this.officialAIbots[0].id)
            }
          }

          if (!this.customAIbots.length) {
            modelChoiceStore.switchTab(10)
          }
        });
      })
      .catch(Loader.error)
      .finally(() => {
        runInAction(() => {
        });
      });
  }


  /**
   * 推荐助手
   */
  getRecommendAIbot = () => {
    request
      .get('/robot/index', {})
      .then(res => {
        const list = res.data?.list || [];
        navbarStore.setChatModels(list);
        runInAction(() => {
          this.recommendAIbots = list;
        });
      })
      .catch(Loader.error)
      .finally(() => {
        runInAction(() => {
        });
      });
  };

  /**
   * 分割助手数据
   * @param {*} array
   * @param {*} chunkSize  每个子数组的大小（首页是8）
   * @returns
   */
  splitArray = (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }

    return result;
  }

  /**
   * 查询助手信息
   */
  findAIbotById = (list, id) => {
    const item = list.find(item => item.id === id);
    if (item) {
      return this.curAIbotInfo = {
        title: item.title,
        icon: item.icon
      };
    }
    return null;
  };

  getHotwords = async () => {
    const res = await request.get('https://papi.look.360.cn/mlist', {
      params: {
        // u: 'test_0d5fdfa4df56f7e8cdcab940ec227501',
        sign: '360_f639c415',
        scene: 315,
        uid: userStore.uid || globalStore.uniqueId,
        n: 3,
        c: 'namimarquee_pc',
        hsid: `${Date.now()}`,
        page: 1,
      }
    })
    if (!Array.isArray(res.data?.res)) return
    let current_item = null
    try {
      const op_ext_list = res.data?.res.map(item => JSON.parse(item.op_ext))
      // console.info('op_ext_list', op_ext_list)
      const index = Math.floor(Math.random() * op_ext_list.length)
      const random = op_ext_list[index]
      if (random && random.nami) {
        current_item = res.data.res[index]
        current_item.index = index // 推荐词所在数组位置
        this.recoWord = random.nami.query
      }
    } catch (error) {
      console.error('><信息流热词格式化', error)
      slsLogger.log({
        key : "papi_look_360_cn_mlist",
        action : `hotwords`,
        arrt: "catch",
        ext : JSON.stringify(res),
      });
    }
    // console.info('><信息流热词', current_item)
    this.recoWordTimer = setTimeout(() => {
      Pingback.initState({
        uid: userStore.uid || globalStore.uniqueId,
        sign: '360_f639c415',
        c: 'namimarquee_pc',
      })
      Pingback.show({...current_item})
    }, 2000)
  }


  /** 获取智能体信息 */
  async getAgentInfo(agentId) {
    if(!agentId) return;

    const backPath = '/'; // /tools/aiagent智能体首页
    request('/ai_agent/detail', {
      method: 'get',
      params: {
        id: agentId,
      }
    }).then(res => {
      if (res.code === 0) {
        if (isEmpty(res.data)) {
          Other.toast('抱歉，该智能体不存在或已被删除', 'warning')
          globalStore.navigate(backPath)
          return
        }
      } else if (res.code === 100004) {
        Other.toast('抱歉，您没有该智能体的访问权限', 'warning')
        globalStore.navigate(backPath)
        return
      } else if (isEmpty(res.data)) {
        Other.toast('抱歉，该智能体不存在或已被删除', 'warning')
        globalStore.navigate(backPath)
        return
      }

      runInAction(() => {
        this.currentAgentInfo = res.data || {}
      })
    }).catch(err => {
      if(err?.code == 500) {
        Other.toast("该智能体已被下架", "warning")
        setTimeout(() => {
          globalStore.hrefNavigate(HelperCore.repaireUrl(backPath));
          return
        }, 2000)
      }
      if (err?.code == 100004) {
        Other.toast('抱歉，您没有该智能体的访问权限', 'warning')
        globalStore.navigate(backPath)
      } else if (isEmpty(err?.data)) {
        Other.toast('抱歉，该智能体不存在或已被删除', 'warning')
        globalStore.navigate(backPath)
      }
    })
  }

}

const homeStore = new Store();
export default homeStore;
